import { loadingAsyncState } from 'widgets-for-react'

import { KnowledgeHighlight } from './knowledgeHighlightState'
import { KnowledgeType } from '../knowledgeUtils'
import { TypeCastingValidator, canSafelyCast } from '../../../../utils/safe-type-casting'
import { imageValidator } from '../../image/imageApi'

type KnowledgeHighlightData = {
  Path: string
  HeaderTitle: string
  HeaderDescription: string
  HeaderImage: {
    Title: string
    Url: string
  }
  KnowledgeType: {
    Title: KnowledgeType
  }
}

export const getKnowledgeHighlight = async (
  id: number
): Promise<any> => {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(
    `/api/v1/knowledge/getById/${id}`,
    { method: 'get', headers: headers }
  )
  if (!res.ok) 
  {
    if (res.status == 404) return null
    throw Error(res.statusText)
  }
  return await res.json()
}

const knowledgeHighlightValidator: TypeCastingValidator<KnowledgeHighlightData> = {
  kind: 'object',
  fieldsValidator: {
    Path: { kind: 'string' },
    HeaderTitle: { kind: 'string' },
    HeaderDescription: { kind: 'string' },
    HeaderImage: imageValidator,
    KnowledgeType: { 
      kind: 'object', 
      fieldsValidator: {
        Title: { kind: 'string' }
      }
    }
  },
}

export const loadKnowledgeHighlight = (id: number) =>
  loadingAsyncState<KnowledgeHighlight | undefined>(() =>
    getKnowledgeHighlight(id).then((raw) => {
      if (raw == null) return { kind: 'result', value: undefined, status: 200 }
      const validationResult = canSafelyCast<KnowledgeHighlightData>(
        knowledgeHighlightValidator,
        raw
      )
      return validationResult.kind == 'r'
        ? { kind: 'result', value: {
          title: validationResult.v.HeaderTitle ?? "",
          introduction: validationResult.v.HeaderDescription ?? "",
          image: validationResult.v.HeaderImage ?? "",
          slug: validationResult.v.Path ?? "",
          type: validationResult.v.KnowledgeType.Title ?? "Techniques" as KnowledgeType,
        }, status: 200 }
        : { kind: 'failed', status: 404 }
    })
  )